import { memo, useState, useRef, useEffect } from "react";

import styles from "./styles.module.scss";
import {
	getReadMoreLabel,
	normalizeCollapsedHeight,
	READ_MORE_LINE_HEIGHT,
} from "./readMorePresentation";

const ReadMore = (props: any) => {
	const { text, maxLines = 0 } = props;
	const [isExpanded, setIsExpanded] = useState<boolean>(false);
	const contentRef = useRef<any>();

	const handleToggle = () => {
		setIsExpanded(!isExpanded);
	};

	const [showMore, setShowMore] = useState(false);
	const collapsedHeight =
		maxLines > 0 ? normalizeCollapsedHeight(maxLines) : undefined;

	useEffect(() => {
		if (!contentRef.current || collapsedHeight === undefined) {
			setShowMore(false);
			return;
		}
		setIsExpanded(false);
		const rafId = requestAnimationFrame(() => {
			if (contentRef.current) {
				setShowMore(
					contentRef.current.scrollHeight > collapsedHeight + 1,
				);
			}
		});
		return () => cancelAnimationFrame(rafId);
	}, [collapsedHeight, text]);

	return (
		<div className={styles.readMore}>
			<div
				ref={contentRef}
				className={isExpanded ? styles.expanded : styles.collapsed}
				style={{
					maxHeight: isExpanded
						? props.maxHeight
							? props.maxHeight
							: "none"
						: collapsedHeight,
					lineHeight: `${READ_MORE_LINE_HEIGHT}px`,
					overflow: isExpanded ? "visible" : "hidden",
					whiteSpace: "break-spaces",
				}}
			>
				{text}
			</div>
			{showMore && (
				<button
					type="button"
					id="read_more"
					className={styles.toggle}
					onClick={handleToggle}
					aria-expanded={isExpanded}
				>
					{getReadMoreLabel(isExpanded)}
				</button>
			)}
		</div>
	);
};

export default memo(ReadMore);
